import { ACTIONS } from '../Constants';

const initialState = {
    newImage: null
};
const imagesReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.UPLOAD_NEW_IMAGE: {
            const { signature } = action.payload;
            return {
                ...state,
                newImage: {
                    url: action.payload.secure_url,
                    id: action.payload.public_id,
                    sig: signature
                }
            };
        }
        default:
            return state;
    }
};
export default imagesReducer;
